import { InjectionToken } from '@angular/core';
import { IsolationInstanceData } from '@app/types/LineIsolation';

/**
 * Copyright (c) 2010-2026 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export const LINE_ISOLATION_INSTANCE_TOKEN = new InjectionToken<IsolationInstanceData>("LINE_ISOLATION_INSTANCE_TOKEN");